<script lang="ts">
  import type { StockTakeEntry } from "../helpers/types";
  import { stockTakeValues } from "../helpers/store";
  import { valueWithCurrency } from "../helpers/utils";

  export let row: StockTakeEntry;

  $: total = $stockTakeValues[row.item_id]
    ? (Math.round($stockTakeValues[row.item_id] * Number(row.current_price) * 100) / 100).toFixed(2)
    : 0;
</script>

<p class="text-medium">{valueWithCurrency(total, row.currency)}</p>
